import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/zoyaspantry.com.au/httpdocs/frontend/src/modules/pages/home-template.js");
